module.exports = ['$stateProvider', $stateProvider =>
  $stateProvider
    .state('patients.id.home', {
      url: '/home',
      views: {
        'content@root': {
          template: '<home>',
        },
      },
    })
    .state('patients.id.update', {
      url: '/update',
      views: {
        'content@root': {
          template: '<profile-management>',
        },
      },
    })
    .state('patients.id.update.profile', {
      parent: 'patients.id.update',
      url: '/profile',
      views: {
        tab: {
          template: '<profile>',
        },
      },
    })
    .state('patients.id.update.personal-information', {
      parent: 'patients.id.update',
      url: '/personal-information',
      views: {
        tab: {
          template: '<personal-informations>',
        },
      },
    })
    .state('patients.id.update.email', {
      parent: 'patients.id.update',
      url: '/email',
      views: {
        tab: {
          template: '<change-email>',
        },
      },
    })
    .state('patients.id.update.password', {
      parent: 'patients.id.update',
      url: '/password',
      views: {
        tab: {
          template: '<change-password>',
        },
      },
    })
    .state('patients.id.update.notification-management', {
      parent: 'patients.id.update',
      url: '/notification-management',
      views: {
        tab: {
          template: '<notification-management>',
        },
      },
    })
    .state('patients.id.update.appointment-reminders', {
      parent: 'patients.id.update',
      url: '/appointment-reminders',
      views: {
        tab: {
          template: '<reminders>',
        },
      },
    }),
];



// WEBPACK FOOTER //
// ./profile/config/routes.js